import {Coupon} from '@wix/auto_sdk_ecom_cart-v-2';
import {AppliedDiscountFragment} from '../../../../gql/graphql';

export class CouponModel {
  public code: string;
  public id: string;

  constructor(params: CouponModel) {
    this.code = params.code;
    this.id = params.id;
  }

  public static fromCheckoutV1(appliedDiscounts: (AppliedDiscountFragment | null)[]) {
    const discount = appliedDiscounts.find((discount) => discount?.coupon);
    const coupon = discount?.coupon;
    if (!coupon) {
      return undefined;
    }
    return new CouponModel({
      code: coupon.code!,
      id: coupon.id!,
    });
  }

  /* istanbul ignore next */
  public static fromCartV2(coupon?: Coupon) {
    if (!coupon) {
      return undefined;
    }
    return new CouponModel({
      code: coupon.code!,
      id: coupon._id!,
    });
  }
}
